import React from 'react';
import type { PopulatedSection } from 'root/apiTypes';
import type { DiscountByItemId } from '@wix/restaurants-normalizers';
import { classes } from './Sections.st.css';
import { Section } from 'root/components/Menus/Section/Section';
import { dataHooks } from 'root/dataHooks';
import { DesignedDivider } from 'root/components/Menus/DesignedDivider/DesignedDivider';

export const Sections = ({
  menuTitleId,
  sections,
  discountInfoByItemId,
}: {
  menuTitleId: string;
  sections: PopulatedSection[];
  discountInfoByItemId?: DiscountByItemId;
}) => {
  return (
    <div
      aria-labelledby={menuTitleId}
      className={classes.sectionsContainer}
      data-hook={dataHooks.sections.container}
      role="list"
    >
      {sections.map((section) => (
        <>
          <DesignedDivider className={classes.dividerTop} dividerName="sectionTopDivider" />
          <Section
            key={section.id}
            discountInfoByItemId={discountInfoByItemId}
            isFirstSection={sections[0].id === section.id}
            section={section}
          />
          <DesignedDivider className={classes.dividerBottom} dividerName="sectionBottomDivider" />
        </>
      ))}
    </div>
  );
};
